<template>
  <b-overlay :show="loading" rounded="sm">
    <div>
      <location-list v-if="isList" title="" ref="table"> </location-list>
      <location-view v-else ref="locationView" :id="id" />
    </div>
  </b-overlay>
</template>
<script>
import LocationList from "./LocationList";
import LocationView from "./LocationView";

import popupMixins from "@/mixins/popupMixins";
import permissionsMixins from "@/mixins/permissionsMixins";

import showItemHelper from "@/mixins/showItemHelper";

export default {
  name: "locations",
  components: {
    LocationList,
    LocationView,
  },
  mixins: [popupMixins, permissionsMixins, showItemHelper],
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.$store.commit("locations/SET_LOCATION", {});
  },
  computed: {
    componentName() {
      return this.$translate("location");
    },
  },

  methods: {},
};
</script>
<style></style>
